import React from "react";

import "./styles.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error(error, info);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="sy-crash" role="alert">
        <h1 className="sy-crash-title">Something went wrong</h1>

        <p className="sy-crash-body">
          Sayagie hit an unexpected error. Reloading usually fixes it.
        </p>

        <button
          type="button"
          className="sy-crash-action"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
